import { normalizarData, normalizarValor } from '../../utils';

/**
 * Retorna TRUE se o array de dados (Sheet->JSON) se parecer com
 * um arquivo de Repasse (Recebíveis) da Cielo.
 */
export const detectar = (dadosArray) => {
    for (let i = 0; i < Math.min(dadosArray.length, 25); i++) {
        const linha = dadosArray[i];
        if (!linha || !Array.isArray(linha)) continue;

        // Limpa a linha para busca mais tolerante
        const cleanRow = linha.map(c => String(c || '').trim().toLowerCase());
        
        // A Cielo geralmente usa "Data" + "Valor líquido" em resumo financeiro
        // Pode ser "Data do vencimento" ou "Data de pagamento" em relatórios detalhados.
        if (
            cleanRow.some(c => c === 'data' || c === 'data de pagamento' || c === 'data do vencimento') && 
            cleanRow.some(c => c === 'valor líquido' || c === 'valor liquido')
        ) {
            return true;
        }
    }
    return false;
};

/**
 * Processa a planilha bruta e retorna array mapeado.
 */
export const processar = (dadosArray) => {
    let idxCabecalho = -1;
    let idxData = -1;
    let idxValor = -1;
    let idxProduto = -1;

    for (let i = 0; i < Math.min(dadosArray.length, 30); i++) {
        const linha = dadosArray[i];
        if (!linha || !Array.isArray(linha)) continue;

        const cleanRow = linha.map(c => String(c || '').trim().toLowerCase());
        
        const possibleDataIdx = cleanRow.findIndex(c => c === 'data' || c === 'data de pagamento' || c === 'data do vencimento');
        const possibleValorIdx = cleanRow.findIndex(c => c === 'valor líquido' || c === 'valor liquido');
        const possibleProdutoIdx = cleanRow.findIndex(c => c.includes('produto') || c.includes('tipo'));

        if (possibleDataIdx !== -1 && possibleValorIdx !== -1) {
            idxCabecalho = i;
            idxData = possibleDataIdx;
            idxValor = possibleValorIdx;
            idxProduto = possibleProdutoIdx;
            break;
        }
    }

    if (idxCabecalho === -1) {
        throw new Error('Cabeçalho não encontrado no parser Cielo.');
    }

    const repasses = [];
    for (let i = idxCabecalho + 1; i < dadosArray.length; i++) {
        const linha = dadosArray[i];
        if (!linha || linha.length === 0) continue;

        const dataStr = String(linha[idxData] || '').trim();
        // A Cielo pode trazer data vazia no final da planilha (totais)
        if (!dataStr) continue;

        const data = normalizarData(dataStr);

        let valor = null;
        if (typeof linha[idxValor] === 'number') {
            valor = linha[idxValor];
        } else {
            valor = normalizarValor(linha[idxValor]);
        }

        let tipoStr = 'Desconhecido';
        if (idxProduto !== -1 && linha[idxProduto]) {
            tipoStr = String(linha[idxProduto]).trim();
        }

        if (data && valor !== null && valor > 0) {
            repasses.push({
                linha: i + 1,
                data: data,
                valor: valor,
                dataOriginal: dataStr,
                tipo: tipoStr
            });
        }
    }

    return repasses;
};
